/** @format */

import React, { Component } from 'react';

import Spacer from '../../../../../../components/Commons/Spacer';
import { formatPrice } from '../../../../../../components/Commons/Hooks/Functions/FormatPrice';

import './style.scss';

export default class DescriptionPrices extends Component {
	render() {
		const { price } = this.props;

		const isNumber = typeof price === 'number' && !Number.isNaN(price);
		
		// Format the price with proper currency symbol
		let formattedPrice;
		if (isNumber) {
			formattedPrice = formatPrice(price);
		} else if (typeof price === 'string' && !isNaN(parseFloat(price))) {
			// If price is a string number, convert and format
			formattedPrice = formatPrice(parseFloat(price));
		} else {
			// Fallback: ensure $ symbol is present
			formattedPrice = typeof price === 'string' && price.includes('$') ? price : `$${price}`;
		}

		return (
			<h3
				className={`${
					this.props.deliveryTotal
						? 'ph-checkout-box-subtotal-price-delivery'
						: this.props.type === 'retirement'
							? 'ph-checkout-box-subtotal-retirement-price'
							: this.props.type === 'products'
								? 'ph-checkout-box-subtotal-products'
								: 'ph-checkout-box-subtotal-price'
				}`}
			>
				{this.props.title}
				<Spacer />
				<span
					className={`${this.props.colorDiscount ? 'ph-checkout-box-subtotal-promotion' : ''} ${
						this.props.colorVoucher ? 'ph-checkout-box-subtotal-voucher' : ''
					} ${this.props.type === 'retirement' ? 'ph-checkout-box-subtotal-retirement' : ''} ph-checkout-box-subtotal-price-info`}
				>
					{formattedPrice}
				</span>
			</h3>
		);
	}
}
